<article class="widget-card" [class.widget-card--chart]="output !== 'number' && output !== 'percentage'"
  [class.widget-card--spreadsheet]="output === 'spreadsheet'">
  @if (output !== 'spreadsheet') {
  <header class="widget-header">
    <div class="widget-heading">
      <span class="widget-icon" aria-hidden="true">
        <app-dashboard-icon [svg]="iconSvg">@switch (icon) {
          @case ('money') { <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-currency-dollar"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2" /><path d="M12 3v3m0 12v3" /></svg> }
          @case ('orders') { <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 9l4 -4l4 4m-4 -4v14" /><path d="M21 15l-4 4l-4 -4m4 4v-14" /></svg> }
          @case ('average') { <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-baseline-density-medium"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 20h16" /><path d="M4 12h16" /><path d="M4 4h16" /></svg> }
          @case ('percentage') { <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle-percentage"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 15.075l6 -6" /><path d="M9 9.105v.015" /><path d="M15 15.12v.015" /></svg> }
          @case ('staff') { <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-user"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" /><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /></svg> }
          @default { <svg viewBox="0 0 24 24"><path d="M4 19V9l5 4 5-8 6 4M4 19h16" /></svg> }
        }</app-dashboard-icon>
      </span>
      <div>
        <h3>{{ title }}</h3>
        @if (subtitle) { <p>{{ subtitle }}</p> }
      </div>
    </div>
    @if (showTimeControls) {
      <div class="time-controls" aria-label="Report time window">
        <label>
          <span>From</span>
          <input type="date" [(ngModel)]="selectedFrom" (change)="reloadForTimeWindow()" />
        </label>
        <label>
          <span>Duration</span>
          <select [(ngModel)]="selectedDuration" (change)="reloadForTimeWindow()">
            @for (days of durationOptions; track days) {
              <option [ngValue]="days">{{ days }} days</option>
            }
          </select>
        </label>
      </div>
    }
  </header>
  }

  <div class="widget-body" [attr.aria-busy]="loading">
    @if (loading) {
      <div class="widget-state">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span>Verifying and loading report…</span>
      </div>
    } @else if (error) {
      <div class="widget-error" role="alert">
        <strong>Widget query error</strong>
        <span>{{ error }}</span>
      </div>
    } @else if (data && output === 'spreadsheet') {
      <app-report-spreadsheet [title]="title" [columns]="data.result.columns" [rows]="data.result.rows"></app-report-spreadsheet>
    } @else if (data && output === 'table' && hasRows) {
      <div class="table-responsive report-table"><table class="table table-vcenter table-sm mb-0"><thead><tr>
        @for (column of data.result.columns; track column.key) { <th>{{ column.label }}</th> }
      </tr></thead><tbody>
        @for (row of data.result.rows; track $index) { <tr>
          @for (column of data.result.columns; track column.key) { <td>{{ formatTableValue(row[column.key], column.data_type) }}</td> }
        </tr> }
      </tbody></table></div>
    } @else if (data && (output === 'number' || output === 'percentage')) {
      <app-report-value
        [value]="scalarValue"
        [dataType]="scalarType"
        [visualization]="visualization"
        [currencyCode]="currencyCode"
        [locale]="locale"
      ></app-report-value>
    } @else if (data && hasRows) {
      <app-report-chart
        [data]="data"
        [visualization]="visualization"
        [colors]="colors"
        [currencyCode]="currencyCode"
        [locale]="locale"
      ></app-report-chart>
    } @else if (data) {
      <div class="widget-state">{{ emptyText }}</div>
    }
  </div>
</article>
